var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutOfStock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 33,
    viewBox: "0 0 89 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8241 3.45065C84.6512 2.28393 83.4623 1.40822 82.0877 1.60176L3.90502 12.5542C2.53222 12.745 1.64807 13.9074 1.81773 15.0707C1.81772 15.0706 1.81774 15.0707 1.81773 15.0707L3.81694 28.6985C3.81941 28.7153 3.82113 28.7321 3.82212 28.7489C4.02118 29.8904 5.19562 30.7384 6.55049 30.5477L84.7354 19.595L84.736 19.5949C86.1087 19.4041 86.9928 18.2419 86.8234 17.0787L86.8233 17.0783M84.8242 3.45131L86.8233 17.0783L84.8242 3.45131ZM84.8241 3.45065L84.8242 3.45131L84.8241 3.45065ZM2.65173 28.8103L0.660901 15.2397C0.385401 13.3519 1.81433 11.6646 3.74377 11.3963C3.74368 11.3963 3.74387 11.3963 3.74377 11.3963L81.9247 0.444072C83.8516 0.172762 85.7022 1.39673 85.9807 3.28029L85.9808 3.28096L87.9801 16.909L87.9802 16.9095C88.2556 18.7972 86.8269 20.4843 84.8976 20.7528M84.897 20.7529L6.71348 31.7054C6.71335 31.7054 6.71321 31.7054 6.71308 31.7054C4.78625 31.9765 2.93592 30.7526 2.65741 28.8691C2.65451 28.8495 2.65262 28.8299 2.65173 28.8103",
    fill: "#F52C48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4951 18.5143L6.46377 29.4425C5.77147 29.5393 5.13326 29.0989 5.03887 28.4592L3.05962 14.9701C2.96522 14.3305 3.45109 13.7346 4.14309 13.6349L82.1773 2.70642C82.8696 2.60961 83.5078 3.05004 83.6022 3.68971L85.5815 17.1788C85.6759 17.8185 85.19 18.4143 84.498 18.514L84.4951 18.5143Z",
    fill: "#F52C48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.313 3.73247C83.2451 3.27221 82.7724 2.9184 82.2177 2.99597L4.18471 13.9243C4.18452 13.9243 4.18434 13.9244 4.18416 13.9244C3.62929 14.0046 3.28124 14.4705 3.34869 14.9275L5.32794 28.4166C5.32793 28.4166 5.32794 28.4167 5.32794 28.4166C5.39589 28.8768 5.86851 29.2307 6.42316 29.1531C6.42314 29.1531 6.42318 29.1531 6.42316 29.1531L84.4545 18.2249C84.4567 18.2246 84.459 18.2243 84.4613 18.2241C85.0135 18.142 85.3595 17.6774 85.2922 17.2216L83.313 3.73247ZM82.1367 2.41705C82.9666 2.301 83.7704 2.82806 83.8913 3.64713L85.8705 17.1362C85.9918 17.9583 85.3684 18.684 84.5396 18.8034C84.5365 18.8038 84.5335 18.8042 84.5305 18.8046C84.5295 18.8047 84.5285 18.8048 84.5275 18.8049L6.50424 29.732C5.67434 29.8481 4.87052 29.321 4.74965 28.502L2.7704 15.0129C2.77039 15.0128 2.7704 15.0129 2.7704 15.0129C2.64916 14.1908 3.27256 13.4651 4.10133 13.3457L4.10248 13.3456L82.1367 2.41705Z",
    fill: "#F52C48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.258 13.982L81.3846 14.2504L78.8127 11.7021L78.3512 12.4455L78.6656 14.64L77.1455 14.8578L76.1224 7.71765L77.6425 7.49985L78.0996 10.6899L80.1689 7.13786L82.0423 6.86944L79.6855 10.6265L83.258 13.982Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2724 15.5438C71.1314 15.8505 69.2574 14.5896 68.943 12.3951C68.6286 10.2006 70.0731 8.46416 72.2141 8.1574C73.7877 7.93192 74.8203 8.65794 75.4507 9.47436L74.2368 10.3038C73.8542 9.76866 73.146 9.40038 72.4073 9.50621C71.112 9.69181 70.3126 10.8223 70.5059 12.1712C70.6992 13.52 71.7838 14.3806 73.0791 14.195C73.8178 14.0891 74.3957 13.5475 74.611 12.9158L76.0075 13.3602C75.621 14.3224 74.846 15.3183 73.2724 15.5438Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.012 16.7274C62.8604 17.0357 61.0659 15.7196 60.7576 13.5679C60.4493 11.4163 61.802 9.64928 63.9537 9.34098C66.1161 9.03115 67.9106 10.3472 68.2189 12.4989C68.5272 14.6506 67.1744 16.4175 65.012 16.7274ZM64.8188 15.3786C66.1355 15.1899 66.8462 14.0502 66.656 12.7228C66.4642 11.3847 65.4637 10.5011 64.147 10.6898C62.8303 10.8785 62.1288 12.0059 62.3205 13.344C62.5107 14.6714 63.5021 15.5672 64.8188 15.3786Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.821 17.4834L57.2902 17.7028L56.4589 11.9007L54.3714 12.1998L54.1797 10.8617L59.8747 10.0457L60.0664 11.3838L57.9897 11.6814L58.821 17.4834Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9143 18.604C50.5441 18.8004 49.4933 18.4812 48.733 17.9019L49.3916 16.6276C49.9699 17.0801 50.8142 17.407 51.7991 17.2659C52.6341 17.1462 52.9856 16.7026 52.9273 16.2958C52.7464 15.0326 48.7599 16.4887 48.3749 13.8018C48.2047 12.6135 49.0912 11.4814 50.7719 11.2406C51.9066 11.078 52.8977 11.2856 53.6978 11.8374L53.0116 13.0719C52.3569 12.6194 51.5509 12.4837 50.8229 12.588C50.1699 12.6815 49.8474 13.0227 49.9087 13.4509C50.0713 14.5856 54.0624 13.2381 54.4443 15.9036C54.6314 17.2096 53.8412 18.3279 51.9143 18.604Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0244 19.89L40.5043 20.1078L39.4812 12.9677L44.5339 12.2437L44.7256 13.5818L41.193 14.088L41.4093 15.5974L44.867 15.1019L45.0587 16.44L41.601 16.9355L42.0244 19.89Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7199 20.9244C33.5682 21.2327 31.7737 19.9167 31.4654 17.765C31.1572 15.6133 32.5099 13.8463 34.6616 13.538C36.824 13.2282 38.6185 14.5442 38.9268 16.6959C39.2351 18.8476 37.8823 20.6146 35.7199 20.9244ZM35.5267 19.5756C36.8434 19.3869 37.554 18.2472 37.3639 16.9198C37.1721 15.5817 36.1716 14.6982 34.8548 14.8868C33.5381 15.0755 32.8366 16.2029 33.0284 17.541C33.2186 18.8684 34.21 19.7642 35.5267 19.5756Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5285 22.1103L24.9977 22.3296L24.1664 16.5275L22.0789 16.8266L21.8872 15.4885L27.5822 14.6725L27.7739 16.0106L25.6972 16.3082L26.5285 22.1103Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7387 23.3575C16.5656 23.6689 15.3417 22.5988 15.0902 20.8432L14.4751 16.5505L16.0166 16.3297L16.624 20.5688C16.7666 21.5644 17.4429 22.1667 18.5455 22.0087C19.6481 21.8507 20.1173 21.0843 19.9746 20.0887L19.3672 15.8496L20.9195 15.6272L21.533 19.9091C21.7876 21.6862 20.9118 23.0461 18.7387 23.3575Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7138 24.5073C8.56214 24.8156 6.76765 23.4995 6.45935 21.3479C6.15105 19.1962 7.5038 17.4292 9.65548 17.1209C11.8179 16.8111 13.6124 18.1271 13.9207 20.2788C14.229 22.4305 12.8762 24.1974 10.7138 24.5073ZM10.5206 23.1585C11.8373 22.9698 12.5479 21.8301 12.3578 20.5027C12.166 19.1646 11.1654 18.281 9.84875 18.4697C8.53204 18.6584 7.83053 19.7858 8.02226 21.1239C8.21246 22.4513 9.20386 23.3471 10.5206 23.1585Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4077_2956",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 87,
    height: 31
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.39778 28.9371L1.39853 15.309C1.17589 13.7834 2.33251 12.3585 3.98374 12.129L82.1653 1.17666C83.8163 0.944217 85.3361 1.99424 85.5617 3.51955L87.5609 17.1476C87.7836 18.6732 86.6269 20.0981 84.9757 20.3277L6.79119 31.2803C5.14025 31.5127 3.62043 30.4627 3.39488 28.9374L3.39778 28.9371Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4077_2956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.033 6.22049C39.4672 5.97247 39.084 5.67063 38.4386 5.9977C38.8983 6.32995 39.2502 6.64085 40.033 6.22049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1884 2.1001C62.4636 1.66671 62.425 1.33572 62.0728 1.10712C61.7627 1.43829 61.5381 1.74316 62.1884 2.1001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03756 18.6241C7.99282 18.473 7.80767 18.3567 7.68269 18.2254C7.53049 18.3466 7.378 18.465 7.13054 18.6605C7.39336 18.7895 7.55412 18.9259 7.72804 18.9317C7.82839 18.9362 8.06038 18.7041 8.03756 18.6241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7922 3.28904C62.1782 2.98246 62.5671 2.67559 62.9528 2.3661C62.4846 2.58702 61.7407 2.60976 61.7922 3.28904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0502 5.26948C86.6941 5.52308 86.2445 5.72449 86.1608 6.28824C86.8817 6.09745 87.0286 5.72117 87.0502 5.26948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1332 5.93835C65.6972 5.72414 65.3817 5.56819 64.9614 5.36414C65.1804 5.76493 65.571 5.95633 66.1332 5.93835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4875 21.9429C51.4191 21.9352 51.3349 22.0025 51.1971 22.0635C51.2218 22.1902 51.2058 22.3505 51.2824 22.469C51.3591 22.5876 51.5282 22.6615 51.7314 22.8112C52.113 22.2877 52.0762 22.0123 51.4846 21.9432L51.4875 21.9429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8485 23.462C45.7586 23.7914 45.6947 24.03 45.6308 24.2686C46.0798 24.0907 46.4596 23.867 45.8485 23.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9029 28.6793C32.9631 28.6644 33.0233 28.6494 33.0864 28.6342C32.9427 28.261 32.799 27.8878 32.6553 27.5146C32.7388 27.9028 32.8194 28.2912 32.9029 28.6793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8571 16.3599C82.8106 16.3646 82.7673 16.372 82.7208 16.3767L82.7917 17.0746C82.8498 17.0686 82.908 17.0627 82.9659 17.0539C82.9306 16.8225 82.8924 16.5913 82.8571 16.3599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0339 13.1019C11.0303 13.067 11.0271 13.035 11.0235 13.0002L10.1279 13.0912C10.1315 13.1261 10.1347 13.1581 10.1383 13.193L11.0339 13.1019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.101 30.1333C25.1546 30.1984 25.2054 30.2638 25.259 30.3288C25.5199 30.2083 25.7835 30.0845 26.0445 29.964C26.0124 29.9085 25.98 29.8501 25.9447 29.792C25.6625 29.9059 25.3832 30.0195 25.101 30.1333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6051 8.02216C75.5496 7.82216 75.494 7.62216 75.4387 7.42507C75.3593 7.4537 75.2803 7.48524 75.198 7.51417C75.2902 7.69869 75.3853 7.88292 75.4775 8.06744C75.52 8.05138 75.5627 8.03822 75.6022 8.02245L75.6051 8.02216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6369 22.9947L24.6128 23.0177C24.6378 23.0328 24.6629 23.0478 24.6879 23.0629C24.671 23.0411 24.6541 23.0193 24.6372 22.9976L24.6369 22.9947Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3667 23.4699C25.1414 23.3342 24.9132 23.1987 24.6879 23.063C24.8374 23.2623 24.9866 23.4586 25.1361 23.6579C25.2119 23.5943 25.2909 23.5334 25.3667 23.4699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8239 22.602C26.8895 22.4955 26.9797 22.4011 26.9599 22.3796C26.8848 22.305 26.7771 22.2572 26.6802 22.1995C26.6457 22.2647 26.5661 22.3491 26.5877 22.3881C26.6312 22.4689 26.7336 22.5231 26.8265 22.5988L26.8239 22.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5921 19.6612C16.6104 19.6388 16.479 19.5023 16.4621 19.5099C16.3604 19.5496 16.2701 19.6146 16.1759 19.6712C16.2499 19.7635 16.2939 19.8208 16.3409 19.8777C16.4277 19.8072 16.53 19.7439 16.5921 19.6612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1907 15.3594C13.2257 15.444 13.3232 15.5076 13.3952 15.5796C13.4631 15.4963 13.531 15.413 13.6384 15.2846C13.4888 15.2293 13.3852 15.1928 13.2813 15.1534C13.2471 15.2215 13.1705 15.3057 13.1904 15.3565L13.1907 15.3594Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.8417 24.0697C69.8264 24.1506 69.8001 24.2091 69.8155 24.2163C69.8964 24.261 69.9881 24.2957 70.0739 24.3311C70.0043 24.253 69.9347 24.1748 69.8417 24.0697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4382 28.3164C13.3815 28.3662 13.3249 28.4161 13.2657 28.4691C13.3036 28.524 13.3386 28.5792 13.3762 28.6312C13.443 28.595 13.5761 28.5462 13.5711 28.5262C13.5489 28.452 13.4863 28.385 13.4382 28.3164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.312 16.3772C72.2314 16.306 72.1588 16.2282 72.0654 16.176C72.0467 16.1662 71.882 16.2798 71.8893 16.2938C71.9363 16.3801 72.0114 16.4547 72.0811 16.5328C72.183 16.4666 72.249 16.4218 72.3152 16.3798L72.312 16.3772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2493 11.7405C46.2836 11.7311 46.345 11.7278 46.3467 11.7159C46.3582 11.656 46.3549 11.5946 46.3545 11.5329C46.3231 11.542 46.2682 11.5505 46.2665 11.5625C46.252 11.6227 46.255 11.6811 46.2496 11.7434L46.2493 11.7405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6332 9.82711C36.6332 9.82711 36.5698 9.83943 36.5355 9.84879C36.5559 9.90547 36.5735 9.96244 36.5913 10.0223C36.6233 10.0191 36.6547 10.01 36.6864 10.0038C36.6685 9.94396 36.6539 9.88669 36.6332 9.82711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0123 4.65741C63.0448 4.60123 63.0802 4.54475 63.1036 4.48655C63.1086 4.47723 63.0533 4.45347 63.025 4.43578C62.9928 4.49487 62.9546 4.55164 62.9311 4.60985C62.9288 4.61596 62.987 4.63942 63.0152 4.65711L63.0123 4.65741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8327 2.9447C54.8879 2.90971 54.9006 2.83204 54.9328 2.77295C54.8592 2.77161 54.7623 2.74327 54.7185 2.77417C54.6633 2.80916 54.6538 2.88944 54.6219 2.95144C54.6955 2.95278 54.7857 2.97299 54.8327 2.9447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0606 5.91093C19.0606 5.91093 19.1252 5.91025 19.1604 5.90961C19.1736 5.83775 19.1843 5.7691 19.1976 5.69724C19.1391 5.70025 19.0804 5.70034 19.0216 5.70044C19.0345 5.76964 19.0448 5.84203 19.0632 5.90773L19.0606 5.91093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5958 27.3033L32.6037 27.3818C32.6201 27.4272 32.6394 27.4722 32.6554 27.5147C32.6443 27.4629 32.6332 27.4112 32.6217 27.3565C32.6138 27.3367 32.6033 27.3202 32.5955 27.3004L32.5958 27.3033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.389 26.8602C32.4567 27.0061 32.5247 27.1549 32.5925 27.3008L32.544 26.8239C32.4922 26.835 32.4408 26.8491 32.389 26.8602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2355 22.7446C24.3485 22.8154 24.4582 22.8836 24.5712 22.9544C24.5021 22.8527 24.433 22.751 24.3671 22.652C24.3232 22.6828 24.2826 22.7164 24.2387 22.7473L24.2355 22.7446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5708 22.9515C24.5848 22.9736 24.5985 22.9928 24.6125 23.0149L24.6366 22.9919C24.6148 22.9794 24.5926 22.964 24.5708 22.9515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9103 25.101C70.8934 25.0793 70.8459 25.0753 70.7883 25.0576C70.8259 25.1096 70.8562 25.1477 70.8833 25.1831C70.8952 25.1555 70.9234 25.1144 70.91 25.0981L70.9103 25.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0991 24.3397C72.0744 24.3275 72.0264 24.3471 71.9892 24.3567C71.9837 24.3896 71.9782 24.4225 71.9728 24.4553C72.0338 24.4491 72.0943 24.4371 72.1551 24.428C72.1373 24.3975 72.1299 24.3542 72.102 24.3394L72.0991 24.3397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.51174 30.6492C2.46344 30.6364 2.41514 30.6237 2.36975 30.6107C2.38434 30.6386 2.39602 30.6668 2.4106 30.6947C2.44431 30.6795 2.47803 30.6643 2.51144 30.6463L2.51174 30.6492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0185 22.648C32.9729 22.6908 32.9274 22.7337 32.8818 22.7765C32.9929 22.8004 33.104 22.8244 33.2149 22.8455C33.1493 22.7787 33.0838 22.7119 33.0185 22.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.61722 20.8431C4.60002 20.8184 4.59066 20.7841 4.56302 20.7722C4.54759 20.765 4.50634 20.7927 4.47815 20.8044C4.49535 20.8291 4.50471 20.8634 4.53236 20.8752C4.54778 20.8825 4.58613 20.8551 4.61722 20.8431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3533 12.5955C80.3513 12.5751 80.3033 12.5653 80.2782 12.5502C80.2477 12.568 80.2198 12.5826 80.1893 12.6004C80.233 12.6253 80.2766 12.6503 80.3174 12.6755C80.3322 12.6476 80.3586 12.6184 80.353 12.5926L80.3533 12.5955Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5108 12.4872L74.4282 12.4839L74.4667 12.5446L74.5108 12.4872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0816 8.98135L76.0946 8.90659L76.0132 8.94424L76.0816 8.98135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.577 7.92217C65.5546 7.93326 65.5498 7.97195 65.5379 7.9996C65.5745 8.01349 65.6112 8.02739 65.6476 8.03839C65.6638 7.99561 65.68 7.95283 65.6959 7.90715C65.6552 7.91128 65.6075 7.90438 65.5767 7.91926L65.577 7.92217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7247 7.28966C62.6734 7.24786 62.6225 7.20897 62.5712 7.16718C62.541 7.18788 62.5134 7.20537 62.4832 7.22607C62.5312 7.26525 62.5799 7.31025 62.6331 7.34303C62.6425 7.34796 62.6913 7.30774 62.7218 7.28995L62.7247 7.28966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3197 7.8314C48.3168 7.80232 48.2702 7.77768 48.244 7.75096C48.2237 7.78241 48.1827 7.81301 48.1828 7.84238C48.1857 7.87146 48.2294 7.8964 48.2556 7.92311C48.2788 7.89138 48.3198 7.86077 48.3168 7.83169L48.3197 7.8314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0597 2.29708C61.0932 2.33774 61.1238 2.37869 61.1576 2.42226C61.1904 2.39836 61.2355 2.37909 61.2532 2.35085C61.2607 2.33834 61.21 2.30236 61.187 2.27825C61.1434 2.28269 61.103 2.28973 61.0597 2.29708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7778 3.38147C56.8061 3.39917 56.8387 3.4311 56.8646 3.42554C56.9024 3.42169 56.9311 3.38646 56.9642 3.36546C56.9202 3.33762 56.8737 3.31297 56.8268 3.28542C56.8094 3.31657 56.792 3.34771 56.7749 3.38177L56.7778 3.38147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3173 30.7901C15.3284 30.8125 15.3398 30.8378 15.348 30.8604C15.382 30.8482 15.4163 30.8388 15.4503 30.8265C15.4389 30.8013 15.4278 30.7789 15.4196 30.7562C15.3856 30.7685 15.3516 30.7807 15.3173 30.7901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6528 27.0667C33.6135 27.056 33.5771 27.045 33.5378 27.0343C33.5655 27.0756 33.5935 27.1197 33.6212 27.161C33.6328 27.1304 33.6441 27.0969 33.6528 27.0667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8863 25.7832C41.9031 25.7463 41.9199 25.7093 41.9367 25.6723C41.9083 25.6811 41.883 25.6925 41.8545 25.7013C41.8662 25.7295 41.8776 25.7547 41.8892 25.7829L41.8863 25.7832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4318 22.841C33.3766 22.8466 33.3184 22.8525 33.2632 22.8581C33.2452 22.8541 33.23 22.8498 33.2123 22.8486C33.2219 22.8565 33.2289 22.8675 33.2385 22.8753C33.3022 22.8659 33.3656 22.8536 33.4318 22.841Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0981 22.7433C31.1045 22.7192 31.1111 22.6979 31.1204 22.6735C31.0904 22.6677 31.0576 22.6623 31.0276 22.6565C31.0512 22.6864 31.0748 22.7163 31.0984 22.7462L31.0981 22.7433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0276 17.4389L76.0304 17.3798L75.9543 17.4111L76.0276 17.4389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5718 17.1704L67.6721 17.1161L67.5632 17.0861L67.5718 17.1704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6348 18.1716C52.6615 18.1748 52.699 18.1387 52.7324 18.1206C52.6904 18.0837 52.6482 18.0439 52.6063 18.0071C52.5918 18.0379 52.5747 18.072 52.5602 18.1028C52.5861 18.1266 52.6051 18.1688 52.635 18.1745L52.6348 18.1716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1714 15.8808C30.1711 15.9072 30.209 15.9328 30.2291 15.9572C30.2296 15.9042 30.2304 15.8542 30.2309 15.8013C30.21 15.8269 30.1716 15.8543 30.1714 15.8808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4835 11.4965L56.4359 11.5777L56.524 11.5775L56.4835 11.4965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5966 10.8575C57.5966 10.8575 57.6091 10.865 57.6155 10.8702C57.6144 10.8586 57.6077 10.8505 57.6036 10.8391C57.5079 10.6785 57.4126 10.5207 57.3169 10.36C57.2703 10.306 57.2211 10.2552 57.1744 10.2012C57.2158 10.2616 57.2543 10.3223 57.296 10.3856C57.3972 10.5428 57.4984 10.7 57.5998 10.8601L57.5966 10.8575Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6857 8.29886L60.6066 8.30103L60.6456 8.36756L60.6857 8.29886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2407 6.2541L54.2935 6.16648L54.1931 6.16199L54.2407 6.2541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1538 7.58259C27.1858 7.57933 27.2428 7.53242 27.2387 7.52108C27.2156 7.46761 27.1757 7.42172 27.1413 7.37234C27.1143 7.42502 27.0786 7.47859 27.0639 7.53591C27.0593 7.54813 27.1248 7.58554 27.1538 7.58259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4904 9.61161C70.5392 9.19536 70.4082 8.7445 69.5236 8.82854C69.429 9.31408 69.3523 9.71555 69.2701 10.1499C69.9494 10.2718 70.4276 10.1497 70.4904 9.61161Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2311 17.4996C55.6813 17.3333 56.1029 17.1172 56.7513 16.8192C55.8826 16.4815 55.0194 16.6309 54.7661 17.0298C54.7128 17.1116 54.7186 17.2843 54.7858 17.3392C54.898 17.4306 55.1232 17.537 55.2308 17.4967L55.2311 17.4996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1301 4.74322C86.4261 4.50455 86.8198 4.30295 86.3423 3.94019C86.2404 3.86242 85.9402 3.8283 85.867 3.88862C85.4386 4.24064 85.6787 4.49239 86.1301 4.74322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2557 30.5978C21.4369 30.0682 21.5524 29.7304 21.6676 29.3896C21.5646 29.359 21.4616 29.3283 21.3615 29.2974C20.9411 29.6133 20.753 29.9585 21.2557 30.5978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8065 4.24901C49.7522 4.32209 49.6977 4.39227 49.6463 4.46506C50.1364 4.66203 50.6262 4.85608 51.1162 5.05305C50.7614 4.68369 50.3311 4.41014 49.8065 4.24901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6653 24.8164C74.3903 24.8561 74.167 24.8847 73.9439 24.9162C73.9714 25.0133 73.9598 25.1584 74.0343 25.1978C74.4034 25.3895 74.5785 25.2336 74.6682 24.8161L74.6653 24.8164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9443 14.8645C33.6513 14.9131 33.7762 14.6095 33.872 14.3089C33.8942 14.2391 33.7757 14.1425 33.6775 13.985C33.4183 14.2963 33.2168 14.5401 32.9443 14.8645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95039 17.4426C4.90434 17.9144 4.85508 18.3836 4.80902 18.8554C5.2527 18.4225 5.19171 17.9381 4.95039 17.4426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9391 15.6643C77.7678 15.6846 77.606 15.7686 77.4414 15.8265C77.4598 15.8628 77.475 15.8965 77.4905 15.9331L78.4326 15.8374C78.4482 15.7888 78.4609 15.7405 78.4766 15.6919C78.2962 15.6808 78.113 15.6407 77.9391 15.6643Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2112 17.3464C33.04 17.1934 32.8687 17.0404 32.6948 16.8906C32.6072 16.9818 32.5163 17.0703 32.4286 17.1615C32.6266 17.2883 32.8213 17.4124 33.0193 17.5392C33.0835 17.4769 33.1473 17.4116 33.2115 17.3493L33.2112 17.3464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1068 17.3411C52.0659 17.401 51.9927 17.4613 51.9984 17.5166C52.0037 17.5689 52.0878 17.6162 52.14 17.6667C52.1965 17.5875 52.2531 17.5083 52.31 17.432C52.2425 17.4036 52.1776 17.3721 52.1098 17.3408L52.1068 17.3411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7109 20.3722C81.6639 20.2859 81.6199 20.1993 81.5732 20.1159C81.4169 20.1965 81.2579 20.2802 81.1016 20.3607C81.1308 20.4165 81.1596 20.4694 81.1859 20.5255C81.36 20.4755 81.5342 20.4254 81.7083 20.3754L81.7109 20.3722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4664 21.3963C44.4805 21.4477 44.5663 21.4831 44.6208 21.5275C44.6631 21.4527 44.7203 21.3793 44.7391 21.3039C44.7434 21.2888 44.6104 21.2524 44.5429 21.224C44.5136 21.2828 44.4527 21.3477 44.4664 21.3963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4535 14.1208C74.5155 14.1527 74.5778 14.1875 74.6447 14.21C74.6538 14.2121 74.7237 14.1491 74.7156 14.1265C74.6951 14.0698 74.6517 14.0184 74.6167 13.9632C74.5633 14.0156 74.5069 14.0683 74.4535 14.1208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9631 18.0689C29.0105 17.8996 29.0615 17.7945 29.0599 17.6919C29.0601 17.636 28.9751 17.58 28.9311 17.5228C28.8469 17.5901 28.7446 17.6534 28.6851 17.7329C28.6697 17.755 28.7661 17.8363 28.9628 18.066L28.9631 18.0689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2939 14.2627C36.3043 14.2205 36.2132 14.1622 36.1669 14.1111C36.1009 14.156 36.0018 14.1925 35.9836 14.2443C35.9697 14.2809 36.0672 14.3445 36.1162 14.3924C36.1795 14.3507 36.2783 14.3113 36.2936 14.2598L36.2939 14.2627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7036 1.53137C85.7645 1.581 85.8251 1.62772 85.8859 1.67735C85.9309 1.62871 85.9817 1.57948 86.0145 1.52621C86.0194 1.51689 85.9516 1.45622 85.9254 1.45888C85.8501 1.46947 85.7775 1.50623 85.7036 1.53137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4938 28.3345C33.5322 28.3364 33.5778 28.3524 33.6089 28.3404C33.6456 28.3249 33.6685 28.2903 33.6978 28.2609C33.6411 28.2519 33.5811 28.2404 33.5224 28.2405C33.5137 28.2414 33.5021 28.3013 33.4909 28.3348L33.4938 28.3345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.4547 21.6826C54.5045 21.7392 54.5543 21.7958 54.6108 21.8606C54.6657 21.8227 54.7669 21.7772 54.7613 21.7513C54.7461 21.6882 54.6817 21.6331 54.6348 21.5761C54.5738 21.6117 54.5157 21.647 54.4547 21.6826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.462 20.3169C65.4199 20.3065 65.3707 20.2851 65.3335 20.2947C65.3073 20.2974 65.2949 20.3486 65.2775 20.3798C65.3121 20.4027 65.3497 20.4253 65.3843 20.4482C65.4122 20.4043 65.4371 20.3606 65.4653 20.3195L65.462 20.3169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71347 22.8477C3.67499 22.7869 3.6539 22.6951 3.59338 22.6777C3.54478 22.6621 3.45503 22.7329 3.3818 22.7639C3.42028 22.8246 3.44137 22.9164 3.49899 22.9341C3.55049 22.9494 3.64024 22.8786 3.71347 22.8477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.1231 8.17883C79.1725 8.14443 79.2119 8.09929 79.2546 8.05676C79.1926 8.02487 79.1306 7.99298 79.0683 7.95818C79.0533 8.01259 79.0295 8.06789 79.032 8.12052C79.034 8.14088 79.1147 8.18262 79.1228 8.17592L79.1231 8.17883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7337 6.84113C76.7032 6.85892 76.6756 6.87641 76.6451 6.8942C76.6966 6.93891 76.7482 6.98361 76.8049 7.02191C76.8113 7.02713 76.8575 6.99012 76.8851 6.97263C76.8336 6.92792 76.7852 6.88583 76.7337 6.84113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.2833 7.11831C68.3128 7.17701 68.3452 7.23541 68.3749 7.29702C68.4205 7.25419 68.5013 7.21073 68.5004 7.17263C68.5 7.11098 68.4411 7.05232 68.4088 6.99392C68.3661 7.03645 68.3263 7.07869 68.2836 7.12122L68.2833 7.11831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.6883 4.28749C84.6883 4.28749 84.7698 4.33796 84.7837 4.33067C84.8418 4.29538 84.8871 4.24965 84.9356 4.20653C84.8739 4.17755 84.8122 4.14856 84.7505 4.11958C84.7268 4.17488 84.7001 4.23047 84.6883 4.28749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6171 3.30756C54.6742 3.34877 54.7283 3.39027 54.7825 3.43177C54.8088 3.37327 54.841 3.31418 54.8526 3.25425C54.8563 3.2333 54.7809 3.18515 54.778 3.18544C54.7199 3.22073 54.6717 3.26676 54.6171 3.30756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2699 2.7565C80.3234 2.79218 80.3802 2.83048 80.4338 2.86616C80.4782 2.81171 80.5229 2.76016 80.5676 2.70861C80.5335 2.69151 80.491 2.64882 80.4683 2.657C80.3971 2.67893 80.3338 2.72062 80.2699 2.7565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9103 9.06876C27.8953 9.00859 27.8574 8.95368 27.828 8.89498C27.801 8.91829 27.7455 8.95037 27.7501 8.96753C27.7651 9.0277 27.803 9.08261 27.8321 9.1384C27.8591 9.11509 27.9149 9.08591 27.9103 9.06876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2546 13.4169L13.1606 13.3883L13.1808 13.4714L13.2546 13.4169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0716 7.48008C85.0654 7.41901 85.033 7.36061 85.0094 7.30132C84.9574 7.33892 84.9083 7.37623 84.8566 7.41674C84.9023 7.46203 84.9484 7.51023 84.9941 7.55553C85.0208 7.52931 85.0737 7.50043 85.0716 7.48008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.2707 8.7466C80.2916 8.72097 80.3299 8.69357 80.3275 8.67031C80.3246 8.64123 80.2838 8.616 80.2605 8.58899C80.2263 8.62772 80.1949 8.66616 80.161 8.70781C80.1976 8.72171 80.2343 8.73561 80.271 8.74951L80.2707 8.7466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5378 9.77306C84.4999 9.71816 84.4483 9.67346 84.3994 9.62555C84.3544 9.67419 84.3091 9.71993 84.2641 9.76857C84.3287 9.79725 84.3907 9.82914 84.4632 9.84822C84.4783 9.85256 84.5448 9.7841 84.5381 9.77597L84.5378 9.77306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80517 18.9059C4.80631 18.8881 4.80774 18.8733 4.80887 18.8555C4.79812 18.8655 4.79058 18.878 4.77693 18.8882C4.70753 19.1303 4.63492 19.3697 4.56231 19.6092L4.56882 19.6732C4.57606 19.6577 4.58331 19.6423 4.59055 19.6269C4.66025 19.3877 4.73256 19.1453 4.80226 18.9062L4.80517 18.9059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.56916 19.6761C4.52308 19.7719 4.47409 19.8679 4.4283 19.9666C4.48502 19.9755 4.54436 19.9812 4.60109 19.9901L4.56946 19.679L4.56916 19.6761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.6529 14.1933C68.6924 14.1775 68.7471 14.1661 68.7622 14.141C68.7746 14.1192 68.7385 14.0817 68.7233 14.048C68.6867 14.0635 68.632 14.0749 68.6141 14.1003C68.6013 14.1192 68.6377 14.1596 68.6526 14.1904L68.6529 14.1933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0138 13.0679C85.0373 13.039 85.0783 13.0084 85.0756 12.9823C85.073 12.9561 85.0264 12.9314 85.0005 12.9076C84.9799 12.9362 84.9389 12.9668 84.9416 12.9929C84.9442 13.0191 84.9905 13.0408 85.0167 13.0676L85.0138 13.0679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2698 17.0402C60.2424 17.0312 60.1956 17.0624 60.1361 17.0831C60.2169 17.0984 60.2769 17.1099 60.3371 17.1244C60.3164 17.0942 60.3 17.0488 60.2698 17.0402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0345 27.582L8.12991 27.5958L8.10685 27.5424L8.0345 27.582Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7637 6.603L31.8567 6.59354L31.7987 6.51424L31.7637 6.603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9392 6.34544C37.9631 6.34889 37.9979 6.31597 38.0287 6.30109C37.99 6.26683 37.9513 6.23258 37.9093 6.19571C37.8945 6.22365 37.8827 6.2513 37.8708 6.27895C37.8938 6.30305 37.9122 6.33937 37.9389 6.34253L37.9392 6.34544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3732 5.18257C51.3182 5.16172 51.2632 5.14087 51.2085 5.12292C51.2222 5.17147 51.2389 5.21972 51.2526 5.26827C51.2939 5.24057 51.3322 5.21317 51.3732 5.18257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2082 5.12008C51.2082 5.12008 51.2 5.09741 51.1959 5.08607C51.1683 5.07419 51.1409 5.06522 51.1133 5.05334C51.1328 5.07193 51.152 5.0876 51.1718 5.10909C51.1841 5.11372 51.1963 5.11835 51.2085 5.12299L51.2082 5.12008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8593 5.90467C55.9341 5.91763 55.9821 5.92744 56.0269 5.93464C56.0155 5.90936 56.0041 5.88407 55.9957 5.85849C55.9616 5.87076 55.9273 5.88013 55.8593 5.90467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1855 9.96446C39.2158 9.97314 39.2486 9.97861 39.2789 9.98729C39.2882 9.96284 39.3108 9.92529 39.3015 9.92036C39.2823 9.90469 39.2439 9.90271 39.2107 9.89433C39.2014 9.91878 39.1948 9.94002 39.1855 9.96446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6106 14.3056C30.5991 14.3362 30.5875 14.3667 30.5759 14.3973C30.6235 14.3748 30.668 14.3497 30.7157 14.3273C30.6796 14.3192 30.6464 14.3108 30.6106 14.3056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1939 18.7606L30.0863 18.8009L30.1815 18.8412L30.1939 18.7606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7356 24.0123C23.7462 23.996 23.7486 23.9897 23.7356 24.0123C23.7525 23.9984 23.7552 23.9951 23.7356 24.0123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9699 24.2248C23.2115 24.1738 23.456 24.1225 23.6976 24.0715C23.7098 24.0468 23.7251 24.0247 23.7324 24.0092C23.7187 24.0194 23.6943 24.0395 23.6696 24.0567C23.4368 24.1069 23.2007 24.1544 22.9678 24.2045L22.9641 24.2254C22.97 24.2836 22.9759 24.3417 22.9815 24.397C22.9756 24.3388 22.9697 24.2807 22.9667 24.2222L22.9699 24.2248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8755 22.2419L44.928 22.3247L44.9688 22.2354L44.8755 22.2419Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4318 14.5695C79.9426 15.7514 80.0052 17.0025 80.0793 18.2523C80.5003 16.9316 80.2555 15.7079 79.4318 14.5695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.1638 13.0761C65.4249 13.0437 65.6718 12.901 65.9224 12.7933C65.6758 12.8243 65.417 12.8799 65.1951 12.8349C64.3127 12.6514 63.5814 12.9138 62.957 13.2446C63.6453 13.1952 64.4089 13.1645 65.1638 13.0761Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0566 14.1011C87.6441 14.0608 87.514 14.3414 87.5668 14.6298C87.595 14.7914 87.7532 14.9311 87.9858 15.2835C88.1783 14.8937 88.3162 14.7475 88.3006 14.6228C88.2784 14.4341 88.1753 14.1126 88.0566 14.1011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.7704 22.0288C77.3893 21.4694 77.8118 21.0886 78.2343 20.7078C78.1339 20.6446 78.0364 20.5811 77.9362 20.5207C77.6674 20.9975 76.9336 21.1779 76.7707 22.0317L76.7704 22.0288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4638 11.187C56.433 11.2019 56.4077 11.2133 56.374 11.2285C56.3075 11.2676 56.2409 11.3066 56.1744 11.3457C56.2505 11.3145 56.3235 11.2806 56.3996 11.2494C56.4211 11.2296 56.4423 11.2068 56.4638 11.187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.678 10.0119C57.1911 10.4815 56.8249 10.839 56.4637 11.1871C57.5582 10.6822 57.5706 10.6604 57.678 10.0119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0598 18.3776C80.0598 18.3776 80.0757 18.3613 80.0839 18.3546C80.0803 18.3197 80.0771 18.2877 80.0764 18.2525C80.0674 18.2798 80.0614 18.3069 80.0524 18.3342C80.0539 18.3488 80.0551 18.3604 80.0566 18.375L80.0598 18.3776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0629 19.7276C79.6702 19.4015 80.1759 19.0299 80.0597 18.3777C79.5845 18.7609 79.3253 19.2456 79.0629 19.7276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1103 17.7862C86.1389 17.8656 86.1649 17.9481 86.1936 18.0275C86.616 17.9346 87.0387 17.8446 87.4614 17.7546C87.4228 17.6352 87.3868 17.5125 87.3483 17.393C86.9355 17.5231 86.523 17.6561 86.1106 17.7891L86.1103 17.7862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2775 19.3779C40.2559 19.339 40.1297 19.34 39.919 19.2909C39.9227 19.5873 39.9225 19.8458 39.9281 20.2477C40.5037 19.9278 40.423 19.6539 40.2775 19.3779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4303 22.2238C85.3049 22.1749 85.1824 22.1256 85.057 22.0767C84.9097 22.3619 84.7624 22.6472 84.6154 22.9353C84.7039 22.9675 84.7927 23.0025 84.8811 23.0347C85.0651 22.7633 85.2464 22.4952 85.4303 22.2238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4982 25.8486C78.944 25.6388 79.1516 25.6001 79.2035 25.5037C79.2728 25.3762 79.2202 25.2053 79.2193 25.0526C79.1475 25.0394 79.0759 25.029 79.0044 25.0187C78.886 25.2128 78.7674 25.4041 78.4956 25.8518L78.4982 25.8486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6113 7.8206C49.6614 7.88013 49.7115 7.93967 49.759 8.00241C49.9848 7.88252 50.208 7.76582 50.4337 7.64592C50.3994 7.59654 50.3679 7.54686 50.3335 7.49747C50.0917 7.60431 49.8499 7.71115 49.6081 7.81798L49.6113 7.8206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86241 23.0345C5.95724 23.0425 6.05206 23.0505 6.14718 23.0614C6.20461 22.7882 6.25913 22.5153 6.31626 22.2393C6.2104 22.2383 6.10424 22.2344 5.99838 22.2334C5.95199 22.4996 5.9059 22.7686 5.86241 23.0345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9829 4.75991C79.8499 4.69411 79.655 4.71391 79.486 4.69877C79.4623 4.75407 79.4385 4.80937 79.4151 4.86757C79.629 4.97803 79.8426 5.08557 80.0595 5.19573C80.1054 5.15582 80.1545 5.11851 80.2003 5.07859C80.1304 4.96819 80.0943 4.81615 79.9832 4.76282L79.9829 4.75991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0631 13.7473C30.1736 13.88 30.2814 14.0159 30.3918 14.1486C30.461 14.1064 30.5981 14.0395 30.5906 14.0227C30.5293 13.882 30.4424 13.7498 30.3607 13.6112C30.2625 13.6565 30.1611 13.6991 30.0628 13.7444L30.0631 13.7473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.8669 20.7135C75.817 20.5981 75.7703 20.4854 75.7204 20.37C75.6805 20.3828 75.6375 20.3931 75.5977 20.406C75.6305 20.526 75.6659 20.6429 75.6986 20.7629C75.7556 20.7454 75.8129 20.7307 75.8672 20.7164L75.8669 20.7135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2562 21.0892C67.3251 21.0734 67.4058 21.0006 67.4232 20.9401C67.4365 20.8976 67.3538 20.8355 67.3162 20.7835C67.2226 20.8459 67.132 20.908 67.0245 20.9777C67.1299 21.0316 67.2044 21.1004 67.2562 21.0892Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7226 14.4347C67.7876 14.3517 67.8968 14.2701 67.9086 14.1837C67.9172 14.1241 67.7927 14.0545 67.7274 13.9906C67.672 14.0814 67.6195 14.1719 67.5717 14.2503C67.6352 14.3261 67.6789 14.3804 67.7226 14.4347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4486 14.62C61.2985 14.5883 61.1484 14.5565 60.9985 14.5277C61.0947 14.6354 61.1937 14.7429 61.2925 14.8474C61.3436 14.7717 61.3975 14.6957 61.4486 14.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5321 28.716C41.5524 28.6845 41.5998 28.6298 41.5901 28.6219C41.5386 28.5772 41.4734 28.5427 41.4111 28.5079C41.3908 28.5394 41.3708 28.5737 41.3508 28.6081C41.4104 28.6461 41.4698 28.6812 41.5295 28.7192L41.5321 28.716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0579 25.9269C59.1393 25.948 59.2389 26.0025 59.295 25.9762C59.3485 25.9532 59.3585 25.8493 59.3839 25.7821C59.3025 25.761 59.2032 25.7094 59.1468 25.7327C59.0931 25.7529 59.086 25.8564 59.0579 25.9269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1289 21.903C76.1433 21.8722 76.1776 21.8334 76.1665 21.811C76.1437 21.7605 76.1012 21.7178 76.0671 21.6713C76.0526 21.7022 76.0381 21.733 76.0233 21.761C76.0574 21.8074 76.0918 21.8568 76.1259 21.9033L76.1289 21.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7536 15.6954C80.7601 15.73 80.7665 15.7646 80.7756 15.796C80.8075 15.7633 80.854 15.7292 80.865 15.6929C80.8746 15.6713 80.83 15.6377 80.8093 15.6075C80.7887 15.636 80.771 15.6642 80.7504 15.6928L80.7536 15.6954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1781 13.2508C50.1144 13.2896 50.0267 13.322 49.9994 13.3718C49.9768 13.4093 50.0336 13.477 50.0567 13.5305C50.1203 13.4917 50.2113 13.4619 50.2414 13.4118C50.2641 13.3742 50.2043 13.3069 50.181 13.2505L50.1781 13.2508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1274 13.9492C20.1535 13.9171 20.092 13.8323 20.068 13.7701C19.9408 13.8477 19.8138 13.9282 19.6866 14.0057C19.7323 14.051 19.778 14.0963 19.8407 14.1634C19.9391 14.0917 20.0536 14.0331 20.1274 13.9492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2232 8.87895C56.2232 8.87895 56.1602 8.80897 56.1434 8.81656C56.078 8.83789 56.0234 8.8787 55.9621 8.91137C56.013 8.95026 56.0669 8.98885 56.1181 9.03065C56.1544 8.98289 56.1965 8.93455 56.2206 8.88216L56.2232 8.87895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6438 13.8074C44.6581 13.8324 44.6753 13.8571 44.7036 13.9042C44.7157 13.8501 44.7235 13.8111 44.7345 13.7747C44.7063 13.7864 44.6752 13.7984 44.6468 13.8071L44.6438 13.8074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16435 15.1165C4.13054 15.0729 4.09674 15.0293 4.06293 14.9858C4.04233 15.0143 4.01882 15.0431 3.99792 15.0688C4.01571 15.0993 4.02625 15.1452 4.05361 15.1542C4.08096 15.1631 4.12453 15.1293 4.16144 15.1168L4.16435 15.1165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1533 20.7712C80.0975 20.8004 80.0487 20.8406 79.9967 20.8782C80.0256 20.9017 80.0515 20.9255 80.0803 20.9491C80.1294 20.9117 80.1814 20.8741 80.2305 20.8368C80.2017 20.8133 80.1588 20.7677 80.1504 20.7715L80.1533 20.7712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5031 24.2064C51.5106 24.2233 51.5182 24.2401 51.5258 24.257C51.5331 24.2709 51.5404 24.2849 51.5477 24.2988C51.5456 24.2785 51.5433 24.2552 51.5441 24.2346C51.5316 24.227 51.5159 24.2169 51.5033 24.2093L51.5031 24.2064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2144 24.0242C51.3116 24.0848 51.4088 24.1455 51.5061 24.2061C51.4611 24.1108 51.4159 24.0126 51.3709 23.9172C51.3187 23.9519 51.2664 23.9866 51.2141 24.0213L51.2144 24.0242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.5028 20.6078C86.5636 20.628 86.6221 20.6544 86.6847 20.6627C86.7027 20.6668 86.7332 20.6196 86.757 20.5937C86.6962 20.5734 86.6354 20.5531 86.5713 20.5303C86.5475 20.5562 86.5263 20.5789 86.5025 20.6048L86.5028 20.6078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5599 24.6207C51.6064 24.616 51.6524 24.6055 51.6986 24.5978C51.6472 24.4973 51.5988 24.3964 51.5475 24.2959C51.5526 24.4041 51.5548 24.5126 51.5599 24.6207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9036 14.1854C38.9552 14.2301 39.0009 14.2754 39.0606 14.3134C39.067 14.3186 39.1419 14.2757 39.1506 14.2455C39.1593 14.2152 39.1286 14.1449 39.117 14.146C39.0443 14.1534 38.9725 14.1695 38.9007 14.1857L38.9036 14.1854Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0886 24.5253L59.1625 24.5295L59.142 24.4728L59.0886 24.5253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4035 15.8936L31.5042 15.901L31.4555 15.8266L31.4035 15.8936Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5207 11.6679C85.4704 11.6348 85.4197 11.5988 85.3693 11.5657C85.3613 11.6018 85.35 11.6353 85.3419 11.6714C85.371 11.6978 85.403 11.7239 85.4322 11.7503C85.4618 11.7238 85.4914 11.6973 85.521 11.6708L85.5207 11.6679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3722 14.6848C72.3504 14.7311 72.4017 14.8023 72.4196 14.8621C72.5032 14.8184 72.5965 14.7825 72.6584 14.7262C72.6744 14.7099 72.5919 14.6214 72.554 14.5664C72.4904 14.6052 72.3965 14.6353 72.3692 14.6851L72.3722 14.6848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8622 24.5142L34.9442 24.4824L34.8592 24.4558L34.8622 24.5142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.037 26.9942C28.0255 27.0247 28.0168 27.055 28.0052 27.0855C28.0442 27.0933 28.0806 27.1043 28.1195 27.1121C28.0921 27.0737 28.0647 27.0354 28.0373 26.9971L28.037 26.9942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9505 30.9885C21.9237 30.9559 21.8966 30.9205 21.8697 30.888C21.8454 30.9081 21.818 30.9285 21.7934 30.9457C21.8132 30.9672 21.8257 31.0041 21.8496 31.0075C21.8796 31.0133 21.9159 30.9949 21.9534 30.9882L21.9505 30.9885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9173 13.9037C42.9173 13.9037 42.9336 13.8609 42.9399 13.8368C42.907 13.8313 42.8736 13.82 42.8445 13.823C42.8329 13.8242 42.8283 13.8657 42.8216 13.887C42.8545 13.8925 42.888 13.9038 42.9171 13.9008L42.9173 13.9037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.069 12.7343C66.0435 12.7428 66.0182 12.7542 65.9926 12.7627C65.967 12.7711 65.9449 12.7851 65.9194 12.7936C65.9513 12.7904 65.9862 12.7868 66.0182 12.7836C66.0342 12.7673 66.0531 12.7506 66.069 12.7343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1681 12.639C66.1327 12.6661 66.101 12.7016 66.0688 12.7313C66.131 12.7074 66.1906 12.6867 66.2531 12.6656C66.2228 12.6569 66.1791 12.632 66.1681 12.639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3136 22.5211L18.2573 22.6032L18.3577 22.6077L18.3136 22.5211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68511 13.1468L3.68319 13.2146L3.77038 13.1763L3.68511 13.1468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.2706 3.21341C84.0062 3.18447 83.7386 3.15291 83.4742 3.12397C83.4636 3.222 83.4556 3.31682 83.445 3.41485C83.7149 3.41092 83.9818 3.40728 84.2517 3.40335C84.2571 3.34111 84.2623 3.27595 84.2706 3.21341Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0766 6.81431C34.1368 6.79938 34.197 6.78445 34.2601 6.76922C34.1164 6.39603 33.9727 6.02285 33.829 5.64966C33.9125 6.03778 33.9931 6.42619 34.0766 6.81431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2775 8.26811C26.3312 8.33317 26.3819 8.39852 26.4355 8.46358C26.6965 8.34305 26.96 8.21931 27.221 8.09877C27.1889 8.04327 27.1565 7.98487 27.1213 7.92676C26.8391 8.04064 26.5598 8.15423 26.2775 8.26811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9147 6.31086C58.9838 6.23921 59.1192 6.15494 59.1052 6.10349C59.0786 6.01512 58.9729 5.92891 58.8716 5.88633C58.8378 5.87213 58.7153 5.99622 58.6032 6.07813C58.7365 6.17621 58.8256 6.24354 58.9147 6.31086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5125 8.50042L34.5765 8.49391L34.536 8.09555L34.472 8.10205L34.5125 8.50042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.018 2.20155C71.0027 2.28242 70.9763 2.34092 70.9918 2.34816C71.0727 2.39282 71.1644 2.42757 71.2502 2.46291C71.1806 2.38479 71.1109 2.30667 71.018 2.20155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6116 6.44849C14.555 6.49831 14.4984 6.54814 14.4391 6.60117C14.477 6.65607 14.512 6.71127 14.5496 6.76327C14.6165 6.72709 14.7496 6.67831 14.7446 6.65825C14.7224 6.58413 14.6597 6.51705 14.6116 6.44849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6811 8.90798C28.7545 8.93578 28.8281 8.96649 28.9014 8.99429C28.9159 8.93406 28.9422 8.87556 28.9418 8.81391C28.9404 8.79937 28.8516 8.76433 28.8321 8.77512C28.774 8.8104 28.7293 8.86195 28.6808 8.90507L28.6811 8.90798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.769 5.43552L33.777 5.51404C33.7933 5.55938 33.8126 5.60442 33.8286 5.64686C33.8175 5.59511 33.8064 5.54336 33.7949 5.4887C33.7871 5.46894 33.7766 5.45238 33.7687 5.43262L33.769 5.43552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5657 4.99484C33.6334 5.14073 33.7014 5.28952 33.7691 5.4354L33.7206 4.95853C33.6689 4.96966 33.6174 4.98371 33.5657 4.99484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0864 3.23276C72.0695 3.21097 72.0221 3.20698 71.9645 3.18933C72.0021 3.24133 72.0324 3.27938 72.0595 3.31481C72.0714 3.28717 72.0995 3.24611 72.0861 3.22985L72.0864 3.23276Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2756 2.47431C73.2509 2.46213 73.2029 2.4817 73.1657 2.49135C73.1602 2.52423 73.1548 2.5571 73.1493 2.58997C73.2104 2.58376 73.2708 2.57174 73.3316 2.56263C73.3138 2.53212 73.3065 2.4888 73.2785 2.47401L73.2756 2.47431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68495 8.78137C3.63666 8.76865 3.58836 8.75593 3.54297 8.74292C3.55756 8.77082 3.56923 8.79901 3.58382 8.8269C3.61753 8.81172 3.65124 8.79655 3.68466 8.77846L3.68495 8.78137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4906 8.92207C16.5017 8.94444 16.5131 8.96972 16.5213 8.9924C16.5553 8.98013 16.5896 8.97076 16.6236 8.95849C16.6122 8.93321 16.6011 8.91083 16.593 8.88816C16.559 8.90043 16.5249 8.9127 16.4906 8.92207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8293 5.20133C34.79 5.19063 34.7536 5.17964 34.7144 5.16895C34.7421 5.2102 34.77 5.25436 34.7977 5.29561C34.8093 5.26505 34.8206 5.23159 34.8293 5.20133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0626 3.91494C43.0794 3.87798 43.0962 3.84101 43.113 3.80405C43.0845 3.81282 43.0592 3.82421 43.0308 3.83298C43.0424 3.86117 43.0538 3.88645 43.0655 3.91464L43.0626 3.91494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8926 27.6093C24.3461 27.3018 24.6427 27.0983 24.9588 26.884C24.7646 26.563 24.6403 26.323 24.4797 26.1013C24.3672 25.9482 24.2044 25.8208 24.0768 25.6928C23.5782 25.7875 23.1559 25.9392 23.2706 26.3741C23.3713 26.7575 23.6333 27.1098 23.8923 27.6064L23.8926 27.6093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7745 8.26753C36.7257 8.68378 36.8567 9.13464 37.7413 9.0506C37.8359 8.56506 37.9126 8.16359 37.9948 7.72925C37.3155 7.60734 36.8373 7.7294 36.7745 8.26753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25962 13.5545C8.36132 12.9654 8.43138 12.4118 7.50747 12.0797C7.19742 13.1336 7.34501 13.4006 8.25962 13.5545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9228 13.9418C21.0247 14.0196 21.3249 14.0537 21.3981 13.9934C21.8265 13.6414 21.5865 13.3896 21.135 13.1388C20.839 13.3775 20.4453 13.5791 20.9228 13.9418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2103 20.5022C11.2266 19.9981 11.0342 19.6945 10.11 19.7356C10.6221 20.0919 10.9162 20.297 11.2103 20.5022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4585 13.633C57.5128 13.5599 57.5674 13.4898 57.6187 13.417C57.1287 13.22 56.6389 13.0259 56.1488 12.829C56.5036 13.1983 56.9339 13.4719 57.4585 13.633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3209 3.01748C73.6138 2.9689 73.489 3.27243 73.3932 3.57301C73.3709 3.64285 73.4894 3.7395 73.5877 3.89697C73.8469 3.58565 74.0483 3.3419 74.3209 3.01748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7973 26.0956C50.353 25.6954 50.4125 25.4719 49.9483 25.096C49.8939 25.457 49.862 25.663 49.7973 26.0956Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5125 16.2774C47.3403 16.0864 47.1707 15.8921 46.9985 15.701C46.9105 15.7599 46.8222 15.8159 46.7341 15.8748C46.9203 16.0585 47.1035 16.2426 47.2893 16.4235C47.3637 16.3748 47.4381 16.3261 47.5125 16.2774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1289 29.6248C16.892 29.549 16.6584 29.4758 16.4215 29.4C16.389 29.4562 16.3563 29.5094 16.3238 29.5656C16.5429 29.6697 16.7621 29.7737 16.9813 29.8778C17.0314 29.7933 17.0787 29.7092 17.1289 29.6248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3338 22.813C83.4333 22.8382 83.5627 22.7809 83.7447 22.7507C83.6427 22.6142 83.5738 22.4567 83.5124 22.46C83.3693 22.4686 83.2313 22.5561 83.0901 22.6116C83.1707 22.6827 83.2346 22.7908 83.3341 22.8159L83.3338 22.813Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1525 21.0739C20.1089 21.1077 20.0624 21.1418 20.0189 21.1756C20.1251 21.3822 20.2313 21.5888 20.3372 21.7925C20.4058 21.7738 20.4712 21.7525 20.5398 21.7337C20.5151 21.607 20.5213 21.4653 20.4574 21.3572C20.3933 21.2463 20.2559 21.1662 20.1525 21.0739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.103 13.3766C78.1798 13.3806 78.2537 13.3848 78.3305 13.3888C78.3665 13.1941 78.4025 12.9995 78.4354 12.8023C78.3525 12.796 78.2696 12.7898 78.1896 12.7832C78.1597 12.9801 78.1329 13.1797 78.103 13.3766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2815 3.63776C71.2954 3.60109 71.1979 3.53756 71.1489 3.48965C71.0856 3.53134 70.9868 3.57077 70.9714 3.62227C70.961 3.66445 71.0522 3.72276 71.0985 3.77387C71.1644 3.72898 71.2635 3.69246 71.2818 3.64067L71.2815 3.63776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4753 12.6559C17.3827 12.583 17.295 12.5009 17.1891 12.4411C17.1704 12.4313 17.076 12.5143 17.0156 12.5557C17.1187 12.6451 17.2218 12.7345 17.3252 12.8268C17.3751 12.7689 17.4251 12.7109 17.4753 12.6559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6406 21.5926C71.615 21.5717 71.5727 21.5319 71.5701 21.5351C71.5097 21.5765 71.4499 21.6237 71.3926 21.6677C71.4314 21.702 71.4701 21.7362 71.5089 21.7705C71.553 21.7131 71.5968 21.6529 71.6409 21.5955L71.6406 21.5926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.08534 30.9923C2.1363 30.8579 2.18727 30.7234 2.24114 30.5887C2.19605 30.5786 2.14834 30.5717 2.10354 30.5645C2.09767 30.709 2.09151 30.8507 2.08854 30.9949L2.08534 30.9923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.74799 31.7199C1.86189 31.4821 1.94652 31.3031 2.03145 31.1271C1.75471 31.2081 1.3601 31.2276 1.74799 31.7199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03168 31.13C2.04883 31.1253 2.06598 31.1207 2.08313 31.116C2.08481 31.0747 2.08679 31.0363 2.08846 30.995C2.07718 31.0284 2.06298 31.0622 2.05169 31.0957C2.04706 31.1079 2.03952 31.1204 2.03488 31.1326L2.03168 31.13Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5614 16.3506C21.5005 16.3009 21.4399 16.2542 21.3791 16.2046C21.3341 16.2532 21.2833 16.3025 21.2505 16.3557C21.2456 16.3651 21.3134 16.4257 21.3396 16.4231C21.4149 16.4125 21.4875 16.3757 21.5614 16.3506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1421 9.70329C28.0927 9.73769 28.0533 9.78283 28.0106 9.82536C28.0726 9.85725 28.1346 9.88914 28.1969 9.92394C28.2119 9.86953 28.2357 9.81423 28.2332 9.7616C28.2312 9.74124 28.1505 9.6995 28.1424 9.7062L28.1421 9.70329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5313 11.0409C30.5618 11.0232 30.5894 11.0057 30.6199 10.9879C30.5683 10.9432 30.5168 10.8985 30.46 10.8602C30.4536 10.8549 30.4074 10.892 30.3798 10.9094C30.4314 10.9542 30.4797 10.9962 30.5313 11.0409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9818 10.7636C38.9523 10.705 38.9199 10.6465 38.8902 10.5849C38.8446 10.6278 38.7638 10.6712 38.7647 10.7093C38.7651 10.771 38.824 10.8296 38.8563 10.888C38.899 10.8455 38.9388 10.8033 38.9815 10.7607L38.9818 10.7636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5767 13.5945C22.5767 13.5945 22.4952 13.5441 22.4812 13.5514C22.4231 13.5866 22.3778 13.6324 22.3293 13.6755C22.391 13.7045 22.4527 13.7335 22.5144 13.7624C22.5382 13.7072 22.5649 13.6516 22.5767 13.5945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9319 23.6723C86.8923 23.6293 86.8309 23.6032 86.7744 23.5678C86.7588 23.6458 86.745 23.7118 86.7311 23.7779C86.7957 23.7772 86.8609 23.7823 86.9245 23.7729C86.9333 23.772 86.9517 23.6938 86.9319 23.6723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6349 30.2959L17.7327 30.3036L17.6901 30.2316L17.6349 30.2959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.538 26.1976C51.5179 26.1732 51.5025 26.1366 51.4751 26.1276C51.4419 26.1192 51.3995 26.1353 51.3588 26.1394C51.3894 26.1804 51.4171 26.2217 51.4477 26.2626C51.4779 26.2419 51.5078 26.2183 51.538 26.1976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6414 27.4375L40.6828 27.4979L40.7269 27.4406L40.6414 27.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4709 23.5829C70.4427 23.5946 70.4116 23.6065 70.3834 23.6182C70.3977 23.6432 70.4146 23.665 70.4394 23.7065C70.4518 23.6553 70.4628 23.619 70.4709 23.5829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6065 20.1007C71.6272 20.131 71.645 20.1615 71.6654 20.1888C71.7052 20.1759 71.7447 20.1601 71.7845 20.1473C71.7638 20.1171 71.7504 20.0714 71.7201 20.0627C71.6928 20.0538 71.646 20.085 71.6065 20.1007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1151 16.0136C68.048 16.0175 67.9849 16.0327 67.9183 16.0424C67.9634 16.0819 68.0063 16.1275 68.0595 16.1602C68.0659 16.1655 68.1174 16.122 68.1476 16.1013C68.1385 16.07 68.1265 16.0095 68.1148 16.0107L68.1151 16.0136Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4097 14.6281C52.406 14.649 52.4814 14.6972 52.4843 14.6969C52.5424 14.6616 52.5906 14.6156 52.6452 14.5748C52.5881 14.5336 52.5339 14.4921 52.4798 14.4506C52.4534 14.5091 52.4212 14.5682 52.4097 14.6281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.992 15.1229C26.9385 15.0872 26.8817 15.0489 26.8281 15.0132C26.7837 15.0677 26.739 15.1193 26.6943 15.1708C26.7283 15.1879 26.7709 15.2306 26.7935 15.2224C26.8648 15.2005 26.9281 15.1588 26.992 15.1229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.3549 8.81325C79.3699 8.87343 79.4078 8.92833 79.4372 8.98703C79.4643 8.96372 79.5197 8.93164 79.5151 8.91449C79.5001 8.85431 79.4622 8.79941 79.4331 8.74361C79.4061 8.76693 79.3503 8.7961 79.3549 8.81325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4085 10.4653C22.3627 10.42 22.3167 10.3718 22.271 10.3265C22.2443 10.3527 22.1914 10.3816 22.1934 10.402C22.1997 10.463 22.232 10.5214 22.2557 10.5807C22.3077 10.5431 22.3568 10.5058 22.4085 10.4653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1045 9.17704C27.0678 9.16314 27.0312 9.14924 26.9945 9.13534C26.9736 9.16097 26.9353 9.18837 26.9376 9.21163C26.9406 9.24071 26.9813 9.26595 27.0047 9.29295C27.0389 9.25422 27.0703 9.21578 27.1042 9.17414L27.1045 9.17704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.998 8.11385C22.9334 8.08516 22.8714 8.05327 22.799 8.03419C22.7838 8.02986 22.7173 8.09831 22.724 8.10644C22.7619 8.16135 22.8135 8.20605 22.8624 8.25396C22.9074 8.20531 22.9527 8.15958 22.9977 8.11094L22.998 8.11385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2872 30.5259L10.3231 30.4459L10.2385 30.4515L10.2872 30.5259Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4805 24.4179C64.463 24.3903 64.4501 24.3505 64.426 24.3441C64.3957 24.3354 64.3539 24.3573 64.3166 24.367C64.344 24.4053 64.3714 24.4437 64.3988 24.482C64.4262 24.4616 64.4535 24.4412 64.4808 24.4208L64.4805 24.4179Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3491 28.2564C24.3773 28.2447 24.4087 28.2356 24.4369 28.2239C24.4223 28.196 24.4077 28.1682 24.396 28.14C24.3795 28.1798 24.3656 28.2165 24.3491 28.2564Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5232 24.3642C32.4932 24.3585 32.4601 24.3501 32.4272 24.3446C32.4316 24.3882 32.4329 24.4292 32.4344 24.4732C32.4684 24.4609 32.5088 24.4538 32.5274 24.4343C32.5407 24.4212 32.5227 24.3878 32.52 24.3616L32.5232 24.3642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0316 17.5808L62.0873 17.4929L61.9869 17.4884L62.0316 17.5808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2177 17.3621C57.1845 17.3537 57.1426 17.3756 57.1025 17.3855C57.1328 17.4236 57.1602 17.4619 57.1906 17.5C57.2208 17.4793 57.251 17.4586 57.278 17.4353C57.2579 17.4109 57.2418 17.3684 57.2148 17.3624L57.2177 17.3621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32768 19.5729L3.23083 19.574L3.2746 19.6577L3.32768 19.5729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4081 11.2856L75.4661 11.3649L75.5011 11.2762L75.4081 11.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3939 11.6003C69.3709 11.5762 69.3526 11.5399 69.3258 11.5367C69.3019 11.5333 69.2671 11.5662 69.2363 11.5811C69.275 11.6153 69.3138 11.6496 69.3557 11.6864C69.3705 11.6585 69.3824 11.6308 69.3942 11.6032L69.3939 11.6003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8918 12.6994C55.9468 12.7203 56.0018 12.7411 56.0565 12.759C56.0427 12.7105 56.0261 12.6622 56.0123 12.6137C55.9711 12.6414 55.9327 12.6688 55.8918 12.6994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0691 12.7961C56.0967 12.8079 56.1241 12.8169 56.1517 12.8288C56.1322 12.8102 56.113 12.7945 56.0932 12.7731C56.081 12.7684 56.0687 12.7638 56.0565 12.7592C56.0577 12.7708 56.0647 12.7818 56.0688 12.7932L56.0691 12.7961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4055 11.9744C51.3307 11.9615 51.2827 11.9517 51.2379 11.9445C51.2493 11.9697 51.2607 11.995 51.2692 12.0206C51.3032 12.0083 51.3375 11.999 51.4055 11.9744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0767 7.91788C68.0465 7.90921 68.0136 7.90374 67.9833 7.89506C67.9741 7.9195 67.9515 7.95706 67.9608 7.96199C67.98 7.97766 68.0184 7.97963 68.0515 7.98801C68.0608 7.96357 68.0675 7.94233 68.0767 7.91788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5491 3.55183C76.5851 3.55991 76.6183 3.56829 76.6541 3.57347C76.6657 3.54291 76.6773 3.51236 76.6888 3.4818C76.6412 3.50428 76.5967 3.52936 76.5491 3.55183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46941 9.66404C8.44294 9.66379 8.41189 9.70514 8.38168 9.72584C8.42303 9.75689 8.46728 9.78765 8.50863 9.8187C8.52051 9.79105 8.535 9.7602 8.54688 9.73255C8.52096 9.70874 8.49617 9.6672 8.4697 9.66695L8.46941 9.66404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.2902 22.8826C76.9214 22.0986 76.9809 21.8458 76.6386 21.628C76.1075 21.2883 75.3879 21.5494 74.7198 22.4047C75.2686 22.5722 75.79 22.7307 76.2902 22.8826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0068 12.4003C34.0624 12.9764 34.2636 13.4818 35.1733 13.6449C34.9082 13.1754 34.6399 12.7032 34.3744 12.2308C34.2509 12.2874 34.1274 12.344 34.0039 12.4006L34.0068 12.4003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9147 15.347C70.8544 14.9272 71.3734 14.4837 70.7368 14.1165C70.1067 14.7779 70.1661 15.1881 70.9147 15.347Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34056 20.9895C2.50177 20.5716 2.40978 20.1001 2.06459 19.575C2.2654 20.0188 1.51103 20.5744 2.34056 20.9895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7087 10.7126C41.6984 10.6109 41.6822 10.5097 41.6716 10.405C41.194 10.3889 40.7114 10.3234 40.2882 10.7836C40.7616 10.759 41.2353 10.7373 41.7087 10.7126Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5022 27.0262C48.6209 27.5871 48.7006 27.9667 48.7835 28.349C49.0885 27.9097 49.3969 27.4465 48.5022 27.0262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.1114 7.37723C51.1845 7.80754 51.2576 8.23784 51.3279 8.66844C51.418 8.65928 51.5081 8.65011 51.6012 8.64066C51.4812 8.21217 51.3642 7.7834 51.244 7.352C51.1978 7.35964 51.1547 7.36989 51.1114 7.37723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4039 18.1311C55.4418 17.6749 55.1254 17.5102 54.4548 17.6371C54.8113 17.8212 55.0811 17.9612 55.4039 18.1311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7239 21.117C56.507 20.6308 56.3549 20.2907 56.2025 19.9478C56.1511 20.4055 56.3249 20.7952 56.7239 21.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4014 24.7003C45.4146 24.2525 45.4222 23.9226 45.4327 23.5925C45.2174 23.9787 45.2069 24.348 45.4014 24.7003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1376 24.3142C41.1256 24.7737 41.1187 25.0241 41.1044 25.5191C41.6024 25.0131 41.6886 24.7635 41.1376 24.3142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2329 12.1536C56.1839 12.279 56.1952 12.4189 56.1772 12.6176C56.6047 12.3724 56.7009 12.1237 56.4657 11.8714C56.3815 11.9681 56.2726 12.0526 56.2329 12.1536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.2395 13.2247L53.1458 12.3029C53.0993 12.3076 53.0501 12.3156 53.0039 12.3232C53.0582 12.6262 53.1125 12.9291 53.1671 13.235C53.1903 13.2326 53.2136 13.2302 53.2398 13.2276L53.2395 13.2247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3155 12.5488C42.1318 12.4764 41.9813 12.383 41.9401 12.4107C41.8102 12.4915 41.7231 12.6178 41.6169 12.7285C41.7077 12.7839 41.8399 12.8997 41.885 12.8805C42.0254 12.8163 42.131 12.6997 42.3157 12.5517L42.3155 12.5488Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0481 25.0095C50.173 24.9086 50.2979 24.8078 50.4257 24.7067C50.3768 24.6588 50.3281 24.6138 50.2792 24.5659C50.1683 24.6888 50.0548 24.8149 49.9439 24.9378C49.9785 24.9607 50.0135 24.9865 50.0481 25.0095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61328 13.8957C9.68129 13.8711 9.7493 13.8466 9.81993 13.8188C9.75601 13.6814 9.6921 13.5439 9.63109 13.4062C9.55785 13.4371 9.41631 13.4897 9.4201 13.4981C9.475 13.6336 9.54675 13.7614 9.61298 13.8928L9.61328 13.8957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3919 14.869C53.371 14.8653 53.3504 14.8644 53.3268 14.8639C53.3043 14.9602 53.2817 15.0565 53.2595 15.1557C53.2892 15.1586 53.3188 15.1614 53.3485 15.1643C53.362 15.066 53.3758 14.9706 53.3893 14.8722L53.3919 14.869Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7489 16.3897C48.8037 16.4664 48.9087 16.5174 49.0072 16.5897C49.0497 16.4884 49.1226 16.3958 49.0964 16.3691C49.0337 16.302 48.924 16.2632 48.8367 16.2133C48.8048 16.2753 48.7282 16.3595 48.7521 16.3923L48.7489 16.3897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1695 28.7945C44.2168 28.7398 44.2644 28.6879 44.3147 28.6329C44.2576 28.5917 44.2031 28.5179 44.1411 28.5154C44.0734 28.5134 43.9973 28.5741 43.9272 28.6076C44.0099 28.6697 44.0897 28.7321 44.1724 28.7942L44.1695 28.7945Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55172 10.5864C5.47568 10.5031 5.40225 10.4165 5.32942 10.3358C5.22828 10.3813 5.15795 10.412 5.08762 10.4426C5.15292 10.5359 5.20456 10.6393 5.29135 10.7128C5.30766 10.7287 5.45931 10.6311 5.55172 10.5864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4341 8.72984C20.4143 8.73772 20.4436 8.88164 20.4553 8.88045C20.5699 8.88056 20.6856 8.86292 20.8397 8.84725C20.7581 8.76741 20.7243 8.69447 20.6707 8.68816C20.596 8.67519 20.5044 8.69919 20.4312 8.73014L20.4341 8.72984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37066 10.8315C8.41901 10.8736 8.4778 10.9029 8.53428 10.9383C8.55168 10.9071 8.57228 10.8786 8.59259 10.8471C8.53611 10.8118 8.48283 10.779 8.42665 10.7465C8.40605 10.775 8.36425 10.8263 8.37096 10.8344L8.37066 10.8315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.412 3.44884C84.4112 3.49886 84.4895 3.54672 84.5326 3.59522C84.5898 3.55121 84.6441 3.5075 84.7014 3.46349C84.6524 3.41559 84.6038 3.37059 84.5577 3.32238C84.5063 3.3658 84.4136 3.40754 84.412 3.44884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77516 12.0455C1.84499 12.0678 1.91251 12.0962 1.98437 12.1094C1.9995 12.1138 2.02996 12.0666 2.05697 12.0433C1.98684 12.0181 1.91671 11.9929 1.84658 11.9677C1.82277 11.9937 1.80187 12.0193 1.77777 12.0423L1.77516 12.0455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6034 12.7698C10.6079 12.8135 10.6882 12.8523 10.7363 12.8915C10.7655 12.8327 10.7951 12.7768 10.8244 12.718C10.779 12.6756 10.7335 12.6332 10.6881 12.5909C10.6559 12.6499 10.5975 12.7117 10.6034 12.7698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4016 10.6135C80.39 10.6441 80.4087 10.6833 80.4122 10.7182C80.4651 10.6893 80.518 10.6604 80.5712 10.6344C80.542 10.608 80.5158 10.5813 80.4899 10.5575C80.4594 10.5753 80.4111 10.592 80.399 10.6167L80.4016 10.6135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9608 6.82613L49.0099 6.75945L48.9127 6.75757L48.9608 6.82613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46163 10.7294C4.38918 10.7104 4.31673 10.6913 4.24428 10.6722C4.2191 10.7423 4.16542 10.8212 4.18558 10.875C4.19814 10.9119 4.32495 10.9167 4.4006 10.9384C4.42288 10.8685 4.44225 10.799 4.46453 10.7291L4.46163 10.7294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2698 16.72L70.1762 16.753L70.2641 16.8087L70.2698 16.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6557 10.5395C54.6353 10.5122 54.6178 10.4846 54.5977 10.4602C54.5521 10.503 54.5004 10.5435 54.4644 10.5942C54.4565 10.6038 54.5017 10.6433 54.5189 10.668C54.5645 10.6251 54.6101 10.5823 54.653 10.5427L54.6557 10.5395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.155 27.269C47.1605 27.2361 47.1657 27.2003 47.1708 27.1646L46.9847 27.1835C47.0028 27.2169 47.0131 27.2599 47.0442 27.2773C47.0661 27.2898 47.1169 27.2699 47.1576 27.2658L47.155 27.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6909 22.5875C77.6909 22.5875 77.6102 22.5458 77.585 22.5572C77.5289 22.5834 77.4836 22.6292 77.4345 22.6665C77.4988 22.6922 77.5631 22.718 77.6277 22.7467C77.6489 22.6946 77.6758 22.6419 77.688 22.5878L77.6909 22.5875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44141 9.47579C8.41027 9.45839 8.37941 9.4439 8.35467 9.43172C8.30647 9.47775 8.25827 9.52378 8.21268 9.56661C8.24644 9.5808 8.29971 9.61358 8.31046 9.60367C8.35955 9.56637 8.39873 9.51832 8.44112 9.47288L8.44141 9.47579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8938 25.0815C62.8938 25.0815 62.9128 25.1531 62.9304 25.21L62.9545 25.187C62.9259 25.137 62.8973 25.0871 62.8938 25.0815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4789 28.9469C13.4904 28.9164 13.4991 28.8861 13.5107 28.8556C13.4717 28.8478 13.4353 28.8368 13.3964 28.829C13.4238 28.8673 13.4512 28.9057 13.4786 28.944L13.4789 28.9469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5684 24.9523C19.5952 24.9849 19.6223 25.0203 19.6491 25.0528C19.6735 25.0327 19.7008 25.0123 19.7255 24.9951C19.7057 24.9736 19.6931 24.9367 19.6693 24.9333C19.6393 24.9275 19.603 24.9459 19.5655 24.9526L19.5684 24.9523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5236 17.183C51.5974 17.1578 51.6639 17.1188 51.7308 17.0826C51.6577 17.0577 51.587 17.0267 51.5093 17.014C51.4945 17.0126 51.439 17.0741 51.442 17.1031C51.445 17.1322 51.5064 17.1877 51.5236 17.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6892 10.3157C64.7156 10.2866 64.7598 10.2586 64.7597 10.2292C64.7597 10.1999 64.7186 10.1717 64.695 10.1418C64.6919 10.1979 64.692 10.2567 64.6892 10.3157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8256 14.9141L9.86414 14.8308L9.77661 14.8368L9.8256 14.9141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2184 1.93615C70.2716 1.93956 70.3245 1.94005 70.3745 1.94084C70.3658 1.91236 70.3677 1.87396 70.3453 1.85568C70.329 1.83971 70.2831 1.85025 70.2508 1.8506C70.2389 1.87825 70.2302 1.90851 70.2184 1.93615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5687 4.14798C45.5376 4.15996 45.4771 4.17198 45.4783 4.18361C45.4786 4.21589 45.5022 4.24581 45.5288 4.3048C45.5453 4.23556 45.5583 4.19017 45.5687 4.14798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.325 22.7146C51.3784 22.6328 51.3726 22.4601 51.3053 22.4052C51.1932 22.3138 50.9679 22.2074 50.8604 22.2477C50.4102 22.414 49.9885 22.6301 49.3402 22.9281C50.2089 23.2658 51.0721 23.1164 51.3253 22.7175L51.325 22.7146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8329 9.14958C84.6517 9.67918 84.5362 10.017 84.4211 10.3578C84.5241 10.3884 84.627 10.4191 84.7271 10.45C85.1475 10.1341 85.3356 9.78887 84.8329 9.14958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4234 14.9311C31.6984 14.8913 31.9217 14.8628 32.1448 14.8313C32.1173 14.7342 32.1289 14.5891 32.0544 14.5496C31.6853 14.358 31.5102 14.5139 31.4205 14.9314L31.4234 14.9311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1443 24.883C72.4372 24.8344 72.3123 25.1379 72.2165 25.4385C72.1943 25.5083 72.3128 25.605 72.4111 25.7624C72.6703 25.4511 72.8717 25.2074 73.1443 24.883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4415 8.63285C23.1478 8.86541 22.9439 9.02715 22.7401 9.18889C23.3425 9.30686 23.6617 9.20978 23.4415 8.63285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.659 23.9097C27.6434 23.9583 27.6306 24.0066 27.615 24.0552C27.7953 24.0663 27.9786 24.1064 28.1525 24.0828C28.3238 24.0625 28.4856 23.9785 28.6501 23.9206C28.6318 23.8843 28.6166 23.8506 28.6011 23.814L27.659 23.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6603 22.589C73.4623 22.4622 73.2676 22.338 73.0696 22.2113C73.0054 22.2736 72.9415 22.3389 72.8774 22.4012C73.0486 22.5542 73.2199 22.7072 73.3938 22.857C73.4817 22.7687 73.5723 22.6772 73.66 22.586L73.6603 22.589Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6053 9.05624C15.6323 9.03293 15.5239 8.89118 15.4232 8.71045C15.2566 8.89191 15.1378 8.99506 15.0621 9.11733C15.0395 9.15488 15.1304 9.23965 15.1721 9.30299C15.3197 9.22335 15.4833 9.15678 15.6053 9.05624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7819 22.318C53.8494 22.3464 53.9143 22.378 53.9821 22.4093C54.023 22.3493 54.0962 22.289 54.0906 22.2338C54.0853 22.1814 54.0011 22.1342 53.949 22.0836C53.8924 22.1628 53.8358 22.242 53.779 22.3183L53.7819 22.318Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3777 19.3754C24.4247 19.4617 24.4687 19.5482 24.5154 19.6316C24.6717 19.5511 24.8307 19.4674 24.987 19.3869C24.9581 19.334 24.929 19.2782 24.9027 19.2221C24.7286 19.2721 24.5545 19.3221 24.3803 19.3722L24.3777 19.3754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7932 22.4202C16.7505 22.6067 16.7104 22.79 16.6705 22.9762C16.7421 22.9865 16.8107 22.9972 16.882 23.0046C16.9309 22.8204 16.9797 22.6363 17.0286 22.4521C16.9512 22.4423 16.8735 22.4297 16.7961 22.4199L16.7932 22.4202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4681 18.2227C61.4258 18.2975 61.3686 18.3709 61.3498 18.4463C61.3455 18.4614 61.4785 18.4978 61.546 18.5262C61.5753 18.4674 61.6362 18.4025 61.6225 18.3539C61.6084 18.3025 61.5226 18.2671 61.4681 18.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6349 25.6268C31.5729 25.5949 31.5106 25.5601 31.4437 25.5375C31.4347 25.5355 31.3647 25.5984 31.3729 25.6211C31.3933 25.6778 31.4367 25.7292 31.4717 25.7844C31.5252 25.7319 31.5815 25.6792 31.6349 25.6268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.0286 22.0556C77.0284 22.1114 77.1134 22.1674 77.1571 22.2217C77.2413 22.1544 77.3436 22.0911 77.4031 22.0116C77.4185 21.9895 77.3221 21.9082 77.1254 21.6785C77.078 21.8478 77.027 21.9529 77.0286 22.0556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.1079 25.5029C70.1218 25.4662 70.0243 25.4027 69.9753 25.3548C69.912 25.3965 69.8132 25.4359 69.7979 25.4874C69.7875 25.5296 69.8786 25.5879 69.9249 25.639C69.9909 25.5941 70.09 25.5576 70.1082 25.5058L70.1079 25.5029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2761 16.1375C10.2635 16.0713 10.2279 16.0102 10.2036 15.9451C10.1769 15.9714 10.1272 16.0028 10.1325 16.0258C10.1451 16.0921 10.1807 16.1531 10.2049 16.2182C10.2314 16.1891 10.281 16.1576 10.2787 16.1343L10.2761 16.1375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5948 11.413C72.5564 11.411 72.5107 11.3951 72.4796 11.4071C72.443 11.4225 72.4201 11.4572 72.3907 11.4866C72.4475 11.4955 72.5074 11.5071 72.5661 11.507C72.5749 11.5061 72.5864 11.4461 72.5977 11.4127L72.5948 11.413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6339 18.065C51.5841 18.0083 51.5343 17.9517 51.4777 17.8869C51.4228 17.9248 51.3217 17.9704 51.3273 17.9962C51.3425 18.0593 51.4069 18.1145 51.4538 18.1714C51.5148 18.1358 51.5729 18.1005 51.6339 18.065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6297 19.4332C40.6719 19.4436 40.7211 19.4651 40.7583 19.4554C40.7845 19.4528 40.7969 19.4016 40.8143 19.3704C40.7796 19.3475 40.7421 19.3249 40.7074 19.3019C40.6796 19.3459 40.6546 19.3896 40.6265 19.4306L40.6297 19.4332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8247 29.9819C21.7601 29.9532 21.6981 29.9213 21.6256 29.9022C21.6105 29.8979 21.544 29.9664 21.5507 29.9745C21.5886 30.0294 21.6401 30.0741 21.6891 30.122C21.7341 30.0734 21.7794 30.0276 21.8244 29.979L21.8247 29.9819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4743 25.6444C37.487 25.6254 37.4506 25.5851 37.4357 25.5543C37.3962 25.57 37.3415 25.5815 37.3265 25.6065C37.314 25.6283 37.3501 25.6658 37.3653 25.6995C37.4019 25.684 37.4566 25.6726 37.4746 25.6473L37.4743 25.6444Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0913 26.8424C21.1119 26.8139 21.1529 26.7833 21.1502 26.7571C21.1475 26.7309 21.1013 26.7092 21.075 26.6825C21.0515 26.7113 21.0106 26.7419 21.0132 26.7681C21.0159 26.7943 21.0625 26.8189 21.0884 26.8427L21.0913 26.8424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8217 22.7069C45.8491 22.7159 45.8958 22.6847 45.9554 22.6639C45.8745 22.6487 45.8143 22.6342 45.7544 22.6227C45.7751 22.6529 45.7915 22.6982 45.8217 22.7069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00346 20.9257C5.99099 20.9475 6.03002 20.9847 6.0449 21.0155C6.08122 20.9971 6.13558 20.9828 6.15067 20.9577C6.16314 20.9359 6.1241 20.8987 6.10922 20.8679C6.0729 20.8863 6.01854 20.9007 6.00346 20.9257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.11367 14.7798L3.00524 14.8114L3.09573 14.8345L3.11367 14.7798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8077 8.18378C25.8304 8.20497 25.8552 8.24652 25.8814 8.24386C25.9133 8.24061 25.9456 8.21089 25.9787 8.1899C25.9754 8.15791 25.9664 8.12652 25.9631 8.09453C25.9132 8.12311 25.8603 8.15199 25.8106 8.18348L25.8077 8.18378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3729 25.4202C75.409 25.4283 75.4422 25.4367 75.478 25.4419C75.4895 25.4113 75.5011 25.3808 75.5127 25.3502C75.465 25.3727 75.4206 25.3978 75.3729 25.4202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.9071 20.9063L75.8976 20.9866L76.0026 20.9495L75.9071 20.9063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3566 15.7383C82.3371 15.7555 82.3398 15.7521 82.3566 15.7383C82.3437 15.7609 82.3461 15.7545 82.3566 15.7383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4186 15.6879C82.6514 15.6378 82.8875 15.5903 83.1204 15.5402L83.1241 15.5192C83.1182 15.4611 83.1123 15.4029 83.1067 15.3477C83.1126 15.4058 83.1185 15.464 83.1215 15.5224C82.8799 15.5734 82.6354 15.6247 82.3938 15.6757C82.3816 15.7005 82.3663 15.7226 82.359 15.738C82.3727 15.7278 82.3971 15.7077 82.4218 15.6905L82.4186 15.6879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1605 17.4227L61.1197 17.5121L61.2159 17.5052L61.1605 17.4227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6441 15.7518C11.6182 15.7279 11.5934 15.6864 11.564 15.6864C11.5375 15.6862 11.5065 15.7276 11.4734 15.7485C11.5176 15.7793 11.5619 15.8101 11.6058 15.8379C11.6177 15.8103 11.6293 15.7797 11.6438 15.7488L11.6441 15.7518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4732 9.83777L51.4609 9.91835L51.5745 9.88036L51.4732 9.83777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11397 14.4983C6.12526 14.4649 6.13654 14.4314 6.14783 14.3979C6.10047 14.4233 6.05601 14.4484 6.00865 14.4738C6.04472 14.4819 6.0808 14.49 6.11367 14.4954L6.11397 14.4983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2516 11.7074L23.1976 11.7834L23.2837 11.7923L23.2516 11.7074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.605 5.95167L58.5714 6.0256L58.6528 6.01732L58.605 5.95167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8625 8.94374L19.8295 9.02348L19.9138 9.01491L19.8625 8.94374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0208 1.5644L83.9691 1.63428L84.0553 1.64316L84.0208 1.5644Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfStock);
export default __webpack_public_path__ + "static/media/out-of-stock.389be28f.svg";
export { ForwardRef as ReactComponent };